import { useEffect } from "react";
import Sidebar from "../sideBar/SideBar";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UserData } from "../../redux/actions/userAuthActions";
import UserToggleHonoraires from "../../components/commons/UserToggleHonoraires";
import UserProfile from "../../components/commons/UserProfile";
import Container from "../../components/Container/Container";
import Modal from "../../components/commons/Modal";
import "./stylesLayout.css";
import MissingLotsNotifications from "../../components/commons/MissingLotsNotifications";

const MainLayout = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const isLoginPage = location.pathname === "/login";
  const isPwdResetPage = location.pathname === "/pwd-reset";
  const dispatch = useDispatch();

  const { role } = useSelector((state) => state.userAuthReducer);

  useEffect(() => {
    dispatch(UserData());
  }, [token, role]);

  return (
    <div>
      {/* Sidebar */}
      {!isLoginPage && !isPwdResetPage && (
        <aside>
          <Sidebar />
        </aside>
      )}

      {/* Main Content */}
      <main
        role="main"
        style={{
          padding: isLoginPage || isPwdResetPage ? "0px" : "20px",
        }}
        className=""
      >
        <div className="mainLayout">
          <div>
            {!isLoginPage && !isPwdResetPage && (
              <div className="header">
                <Container className="toggleContainer ">
                  <MissingLotsNotifications />
                  {location.pathname === "/backoffice" ||
                  location.pathname === "/immobilier" ? (
                    <UserToggleHonoraires />
                  ) : null}
                  <UserProfile />
                </Container>
              </div>
            )}
            <Container className="mainContent p-0">{children}</Container>
          </div>
        </div>
      </main>

      {/* Modal */}
      <Modal />
    </div>
  );
};

export default MainLayout;
